__turbopack_context__.v({
  "apiVersion": "l_R8bG_apiVersion",
  "apiVersionText": "l_R8bG_apiVersionText",
  "wrapper": "l_R8bG_wrapper",
});
